const setBitByPosition = (n: number, bitPosition: number, bitValue: 0 | 1): number => {
  const mask = ~(1 << bitPosition);

  return (n & mask) | (bitValue << bitPosition);
};

export default setBitByPosition;
